import api from './APIService';

class EventWaiverService {
	getRelationshipList($data) {
		return api.fetch({ method: 'post', path: '/participant/events/waivers/getRelationshipList', data: $data});
	}
    getEventList() {
		return api.fetch({ method: 'get', path: '/participant/events/waivers/getEventList'});
	}
	getWaiverForEventList($data) {
		return api.fetch({ method: 'post', path: '/participant/events/waivers/getWaiverForEventList', data: $data});
	}
	generateWaiverForSpectator($data) {
		return api.fetch({ method: 'post', path: '/participant/events/waivers/generateWaiverForSpectator', data: $data });
	}
	generateWaiverForType($data) {
		return api.fetch({ method: 'post', path: '/participant/events/waivers/generateWaiverForType', data: $data });
	}
	generateWaiverForEventWaiverSigned($data) {
		return api.fetch({ method: 'get', path: `/participant/events/waivers/eventWaiverSigned/${$data}`});
	}
	generateWaiverForEventWaiverSignedType($event,$type,$user) {
		return api.fetch({ method: 'get', path: `/participant/events/waivers/getEventWaiverSignedType/${$event}/${$type}/${$user}`});
	}
	generateWaiverByEventWaiverId($data) {
		return api.fetch({ method: 'post', path: '/participant/events/waivers/generateWaiverByEventWaiverId', data: $data });
	}
	eventWaiverType($data) {
		return api.fetch({ method: 'get', path: `/participant/events/waivers/eventWaiverType/${$data}`});
	}
	getLinkedMembersWaiver() {
		return api.fetch({ method: 'get', path: 'participant/events/waivers/getLinkedMembersWaiver' });
	}
	deleteWaiver($id) {
		return api.fetch({ method: 'delete', path: `participant/events/waivers/${$id}`});
	}
	getEvent($eventId) {
		return api.fetch({ method: 'get', path: `participant/events/waivers/getEvent/${$eventId}` })
	}
	sendWaiver($data) {
		return api.fetch({ method: 'post', path: 'participant/waivers/sendWaiver', data: $data})
	}
	getWaiversForUser($data) {
		return api.fetch({ method: 'post', path: 'participant/events/waivers/getWaiversForUserEventRole', data: $data});
	}
}

export default new EventWaiverService();
